import React from 'react';
import VoucherGlobalHeader from '../../components/voucher-global-header/voucher-global-header';
import VoucherImage from '../../components/voucher-image/voucher-image';
import ZLSection from '../../containers/zl-section/zl-section';

export interface IGlobalGiftVoucherHeadingSectionProps {
    active: boolean;
    scrollTo?: boolean;
}

const GlobalGiftVoucherHeadingSection: React.FunctionComponent<IGlobalGiftVoucherHeadingSectionProps> = (props) => {
    const { active, scrollTo } = props;

    return (
        <ZLSection title={''} active={active} scrollTo={scrollTo}>
            <VoucherImage showImage={true} showExpiary={false} />
            <br/>
            <VoucherGlobalHeader/>
        </ZLSection>
    );
};

export default GlobalGiftVoucherHeadingSection;
